import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import {
  bouyguesAuthRoutes,
  bouyguesFlowRoutes,
  bouyguesWebviewFlowRoutes,
} from './bouygues-routes'
import { freenetFlowRoutes } from './freenet-routes'
import forwardPartnerQueryMiddleware from './middleware/forwardPartnerQueryMiddleware/forwardPartnerQueryMiddleware'
import { CHECKOUT_E_COMMERCE } from './route-names'

const routes: RouteRecordRaw[] = [
  {
    path: 'f2',
    name: CHECKOUT_E_COMMERCE.SELF,
    component: () =>
      import('@backmarket/nuxt-layer-checkout/components/CheckoutFlow/CheckoutFlow.vue'),
    props: {
      withHeader: true,
    },
    redirect: { name: CHECKOUT_E_COMMERCE.CART },
    meta: {
      owners: ['bot-squad-checkout-front'],
      layout: false,
      middleware: [forwardPartnerQueryMiddleware],
      tracking: { contentGroup: 'Checkout' },
    },
    children: [
      {
        name: CHECKOUT_E_COMMERCE.CART,
        path: 'cart',
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/CartStep/CartStep.vue'),
        meta: {
          owners: ['bot-squad-checkout-front'],
          gtmStepId: 1,
          tracking: { contentGroup: 'Cart' },
        },
      },
      {
        path: 'addresses',
        name: CHECKOUT_E_COMMERCE.ADDRESSES,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/AddressesStep/AddressesStep.vue'),
        meta: {
          owners: ['bot-squad-checkout-front'],
          auth: {
            required: true,
            redirection: {
              name: ROUTES.AUTH.LOGIN,
              query: { bm_journey: 'checkout' },
            },
          },
          gtmStepId: 4,
        },
      },
      {
        path: 'services',
        name: CHECKOUT_E_COMMERCE.SERVICES.ROOT,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/ServicesRoot/ServicesRoot.vue'),
        meta: {
          owners: ['bot-squad-partnerships-front'],
          auth: {
            required: true,
            redirection: {
              name: ROUTES.AUTH.LOGIN,
              query: { bm_journey: 'checkout' },
            },
          },
          tracking: { contentGroup: 'Services Checkout' },
        },
      },
      ...bouyguesFlowRoutes,
      ...freenetFlowRoutes,
      {
        path: 'payment',
        name: CHECKOUT_E_COMMERCE.PAYMENT,
        component: () =>
          import('~/scopes/checkout/flows/e-commerce/pages/PaymentStep/PaymentStep.vue'),
        meta: {
          owners: ['bot-squad-checkout-front'],
          auth: {
            required: true,
            redirection: {
              name: ROUTES.AUTH.LOGIN,
              query: { bm_journey: 'checkout' },
            },
          },
          payment: {
            contentSecurityPoliciesEnabled: true,
          },
          gtmStepId: 6,
        },
      },
    ],
  },
  {
    path: 'f2/payment-result/:paymentId?',
    name: CHECKOUT_E_COMMERCE.PAYMENT_RESULT,
    component: () => import('~/scopes/checkout/pages/Result/Result.vue'),
    meta: {
      owners: ['bot-squad-checkout-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
      tracking: { contentGroup: 'Checkout' },
    },
  },
  ...bouyguesAuthRoutes,
  ...bouyguesWebviewFlowRoutes,
]

export default routes
